/** @jsx h */
import { h } from 'preact'
import StoryCard from './StoryCard'
import InfiniteModal from '../../InfiniteModal'

export const StoryCardListForInfiniteModal = ({ journeys, openStoryIndex, closeStory }) =>
  journeys.map((journey, index) => [
    <StoryCard revealed={openStoryIndex === index} coverSlideDisabled {...journey} creditsSlideDisabled key={`StoryCard${index}`} />,
    openStoryIndex === index ? <InfiniteModal.Back onClick={closeStory(index)} key={`InfiniteModal.Back${index}`} /> : null
  ])

export default StoryCardListForInfiniteModal
